module.exports = __webpack_public_path__ + "bfd2a468424327eaf928ebd1ecc3b238.pdf";